import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
// import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  AccordionDetails,
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  Tooltip
} from '@mui/material';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import React, { createRef, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { useUtil } from 'src/components/hooks/useUtil';
import { useDeleteSitePersonnelMutation } from 'src/services/SiteContactInfo';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useGetKeycloakGroupsQuery } from 'src/services/workarea';
import { useAppDispatch, useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { setPath } from 'src/store/Navigation';
import { setIsbacktositepersonnel } from 'src/store/SiteStudyPersonnel';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import forms from '../../../resources/forms.json';
import './Steps.scss';
import UserAccessRequestModal from './UserAccessRequestModal';
import { useSiteContactInfo } from './useSitecontactinfo';
import moment from 'moment';

const SitePersonal: React.FunctionComponent<any> = ({ setIsEnableAddPer, handleClickStudyLogs, list }) => {
  const { getServerDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [isSaveDisable, setIsSaveDisable] = useState(true);
  const { setTabVal, tabsData } = useTab();
  const { user } = useUser();
  const formGroup = forms.siteContactInformation_SitePersonal;
  const [codes, setCodes] = useState<any>({});
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups, codes);
  const studyId = useAppSelector(state => state.site.selectedStudy);
  const [reqBtnText, setReqBtnText] = useState('REQUEST ACCESS');
  const { groups } = formFields;
  const [listOfPersonnals, setListOfPersonnals] = useState<any>([]);
  const [selectedPersonnals, setSelectedPersonnals] = useState<any>([]);
  const [addPersonnelActive, setAddPersonnelActive] = useState(false);
  const [openActivitiesDilog, setOpenActivitiesDilog] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openUserAccess, setOpenUserAccess] = useState(false);
  const [checkedCheckBoxval, setcheckedCheckBoxval] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [oprativePersonnal, setOprativePersonnal] = useState<any>({});
  const [isEmailErrorBlock, setIsEmailErrorBlock] = useState(false);
  const formRefs: any = useRef([]);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const { data }: any = useGetCodeListDataQuery('STACTIV');
  const { checkPermission } = usePermissionWrapper();
  const { openModal, closeModal } = useUtil();
  const [studyActivitiesData, setStudyActivitiesData] = useState<any>([]);
  const { data: personelRoleData } = useGetCodeListDataQuery('STPRROL');
  const { data: keyCloakGroups } = useGetKeycloakGroupsQuery();
  const {
    createSitePersonal,
    updateSitePersonal,
    createSitePersonalSuccess,
    updateSitePersonalSuccess,
    createSitePersonalIsError
  } = useSiteContactInfo();
  const [
    deleteSitePersonnel,
    {
      data: deleteSitePersonnelData,
      isSuccess: deleteSitePersonnelIsSuccess,
      isError: deleteSitePersonnelIsError,
      isLoading: deleteSitePersonnelIsLoading,
      error: deleteSitePersonnelError
    }
  ] = useDeleteSitePersonnelMutation();
  useEffect(() => {
    if (list?.length) {
      setListOfPersonnals(
        list.map((ele: any) => {
          return {
            ...ele,
            key: ele.id,
            isOld: true,
            site_per_startdate: ele.site_per_startdate ? ele.site_per_startdate : ele.date_granted
          };
        })
      );
    } else {
      setListOfPersonnals([]);
    }
  }, [list]);
  useEffect(() => {
    if (keyCloakGroups && !codes.FRD) {
      const FRD = keyCloakGroups.map((item: any) => {
        return { displayName: item.name, key: item.name };
      });
      setCodes({ ...codes, FRD });
    }
  }, [keyCloakGroups, codes]);
  useEffect(() => {
    if (personelRoleData && !codes.STPRROL) {
      const tempSTPRROL: any = personelRoleData;
      setCodes({
        ...codes,
        STPRROL: tempSTPRROL.map((ele: any) => {
          return { displayName: ele.code_list_value, key: ele.code_list_value };
        })
      });
    }
  }, [personelRoleData, codes]);
  useEffect(() => {
    if (data && !studyActivitiesData.length) {
      const temp: any[] = [];
      data.map((ele: any, index: number) => {
        if (ele !== 'Other') {
          temp.push({ id: index + 1, ele: ele.code_list_value });
        }
      });
      setStudyActivitiesData(temp);
    }
  }, [data]);
  useEffect(() => {
    if (openDrawer) {
      openModal();
    } else {
      closeModal();
    }
    return () => {
      closeModal();
    };
  }, [openDrawer]);
  const handleClick = () => {
    setOpenDrawer(true);
  };
  const InputAdornmentCMP = (
    <Tooltip title="View Study Activities" placement="top" arrow>
      <InputAdornment position="end" onClick={handleClick}>
        <InfoOutlinedIcon />
      </InputAdornment>
    </Tooltip>
  );
  useEffect(() => {
    if (groups[2]) {
      groups[1].fields[1] = {
        ...groups[1].fields[1],
        InputProps: { endAdornment: InputAdornmentCMP }
      };
    }
  }, []);
  const onClick = (cmp: any, personnel: any) => {
    if (cmp === 'site_per_activities' && !openActivitiesDilog && document.activeElement !== null) {
      setOprativePersonnal(personnel);
      setOpenActivitiesDilog(true);
      if (personnel.site_per_activities) {
        setcheckedCheckBoxval(personnel.site_per_activities.split(','));
      } else {
        setcheckedCheckBoxval([]);
      }
    }
  };
  const handleAddPersonnel = () => {
    setListOfPersonnals([
      ...listOfPersonnals,
      {
        ...defaultValues,
        id: `personnel${listOfPersonnals.length}`,
        isNew: true,
        site_per_study: studyId,
        site_per_training: 'Y',
        fics_system: 'Study side FICS- TSDA',
        site_per_startdate: null,
        site_per_enddate: null,
        key: crypto.randomUUID()
      }
    ]);
    if (isSaveDisable) {
      setIsSaveDisable(false);
    }
    setAddPersonnelActive(true);
    setIsEmailErrorBlock(false);
  };
  const [lastChangedData, setLastChangedData] = useState(null);
  const handlechangeFunction = (key: string, value: string, id: string, isNew = false) => {
    if (key) {
      if (
        key === 'site_per_role' &&
        listOfPersonnals.find((personnel: any) => personnel.id === id && personnel.site_per_role && personnel.isOld)
      ) {
        dispatch(
          setMessage({
            msgDetails: 'Updating role may impact site activities associated with this user',
            severity: 'warning'
          })
        );
        setListOfPersonnals(
          listOfPersonnals.map((personnel: any) => {
            if (personnel.id === id) {
              setLastChangedData({ ...personnel, [key]: value });
              return { ...personnel, [key]: value, isOld: false };
            } else {
              return personnel;
            }
          })
        );
      } else if (key === 'site_per_role') {
        setListOfPersonnals(
          listOfPersonnals.map((personnel: any) => {
            if (personnel.id === id) {
              setLastChangedData({ ...personnel, [key]: value });
              return { ...personnel, [key]: value, isOld: false };
            } else {
              return personnel;
            }
          })
        );
      } else {
        setListOfPersonnals(
          listOfPersonnals.map((personnel: any) => {
            if (personnel.id === id) {
              setLastChangedData({ ...personnel, [key]: value });
              return { ...personnel, [key]: value };
            } else {
              return personnel;
            }
          })
        );
      }
    }
    if (isSaveDisable) {
      setIsSaveDisable(false);
    }
    if (isNew && isEmailErrorBlock && (key === 'site_per_email' || key === 'site_per_login')) {
      setIsEmailErrorBlock(false);
    }
    setDuplicates([]);
  };
  const handleRequest = (id: string, e: any) => {
    if (e.target.checked) {
      setSelectedPersonnals([...selectedPersonnals, id]);
    } else {
      setSelectedPersonnals(selectedPersonnals.filter((personnal: any) => personnal !== id));
    }
    if (reqBtnText !== 'REQUEST ACCESS') {
      setReqBtnText('REQUEST ACCESS');
    }
  };
  const handleClickOpen = () => {
    setOpenUserAccess(true);
  };
  const [duplicateIds, setDuplicates] = useState<any>([]);
  const updateLatestSitePersonnel = (tempUpdatedPersonnal: any[], errorDivId: string | null) => {
    if (tempUpdatedPersonnal.length && !errorDivId) {
      if (checkPermission('create_site_personnel')) {
        updateSitePersonal({
          data: {
            personnel: tempUpdatedPersonnal.map((ele: any) => {
              return {
                ...ele,
                personnel_id: ele.id,
                site_per_startdate: getServerDateFormat(ele.site_per_startdate),
                site_per_enddate: ele.site_per_enddate !== null ? getServerDateFormat(ele.site_per_enddate) : null
              };
            }),
            display_request_id: null
          },
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          application: process.env.REACT_APP_NAME
        });
      }
    }
  };
  const handleSave = async () => {
    const tempUpdatedPersonnal: any = [];
    const tempNewPersonnal: any = [];
    let isCheckError = false;
    let errorDivId: null | string = null;
    const fromReqIds: any = [];
    let isDuplicate = false;
    formRefs.current.map((currentForm: any) => {
      if (currentForm.formRef.current !== null) {
        currentForm.formRef.current.submit(async (data: any) => {
          if (data.errors) {
            if (errorDivId === null) {
              errorDivId = currentForm?.id;
            }
            isCheckError = true;
            return;
          }
          if (data.success) {
            const formData: any = lastChangedData; //data.records
            const found = fromReqIds.find((obj: any) => {
              if (
                obj?.id !== formData?.id &&
                obj?.site_per_designation?.toLowerCase() == formData?.site_per_designation?.toLowerCase() &&
                obj?.site_per_email?.toLowerCase() == formData?.site_per_email?.toLowerCase() &&
                obj?.site_per_first_name?.toLowerCase() == formData?.site_per_first_name?.toLowerCase() &&
                obj?.site_per_frole == formData?.site_per_frole &&
                obj?.site_per_last_name?.toLowerCase() == formData?.site_per_last_name?.toLowerCase() &&
                obj?.site_per_login?.toLowerCase() == formData?.site_per_login?.toLowerCase() &&
                obj?.site_per_number == formData?.site_per_number &&
                obj?.site_per_role == formData?.site_per_role &&
                moment(obj?.site_per_startdate).format() == moment(formData?.site_per_startdate).format() &&
                moment(obj?.site_per_enddate).format() == moment(formData?.site_per_enddate).format() &&
                obj?.site_per_training == formData?.site_per_training
              ) {
                return obj;
              }
            });
            if (found) {
              isDuplicate = true;
              errorDivId = formData.id; //currentForm?.id;
            } else {
              fromReqIds.push({
                ...data.records
              });
            }
            if (!data.records.isNew) {
              const find = listOfPersonnals.find((ele: any) => ele.id === data.records.id);
              tempUpdatedPersonnal.push({
                ...data.records,
                site_per_training: find?.site_per_training
              });
            } else if (data.records.isNew) {
              const find = listOfPersonnals.find((ele: any) => ele.id === data.records.id);
              tempNewPersonnal.push({
                ...data.records,
                created_by: user,
                site_per_training: find?.site_per_training
              });
            }
          }
        });
      }
    });

    if (!isDuplicate) {
      const updatedPersonnelData = tempUpdatedPersonnal.map((ele: any) => {
        return { ...ele, isOld: true };
      });
      if (tempNewPersonnal.length) {
        const data = {
          personnel: tempNewPersonnal.map((ele: any) => {
            return {
              ...ele,
              site_per_enddate:
                ele.site_per_enddate !== null ? getServerDateFormat(ele.site_per_enddate) : ele.site_per_enddate,
              site_per_startdate: getServerDateFormat(ele.site_per_startdate)
            };
          }),
          display_request_id: null
        };
        const createSitePersonalData: any = await createSitePersonal({
          study_id: studyId,
          data,
          site_id: selectedSite,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        if (createSitePersonalData?.error) {
          dispatch(
            setMessage({
              msgDetails: `${
                createSitePersonalData?.error?.data?.context?.message ||
                createSitePersonalData?.error?.data?.detail ||
                'Error Data'
              }`,
              severity: 'error'
            })
          );
          setIsEmailErrorBlock(true);
          updateLatestSitePersonnel(updatedPersonnelData, errorDivId);
          setListOfPersonnals([...updatedPersonnelData]);
        } else if (createSitePersonalData.data.length && !createSitePersonalData?.error) {
          updateLatestSitePersonnel(updatedPersonnelData, errorDivId);
          setListOfPersonnals([
            ...updatedPersonnelData,
            ...createSitePersonalData.data.map((ele: any) => {
              return { ...ele, isOld: true };
            })
          ]);
        } else {
          setListOfPersonnals([...updatedPersonnelData]);
        }
      } else {
        updateLatestSitePersonnel(updatedPersonnelData, errorDivId);
        setListOfPersonnals([...updatedPersonnelData]);
      }
    } else {
      dispatch(
        setMessage({
          msgDetails: 'Duplicate Personnel added',
          severity: 'error'
        })
      );
      setDuplicates([...duplicateIds, errorDivId]);
    }
    if (isCheckError || isDuplicate) {
      if (errorDivId !== null) {
        const curentDiv: any = document.getElementById(errorDivId);
        if (curentDiv) {
          curentDiv.scrollIntoView();
        }
      }
      return;
    }
  };
  const handleRemovePersonnal = (personnel: any) => {
    if (personnel.isNew) {
      setListOfPersonnals(listOfPersonnals.filter((item: any) => item.id !== personnel.id));
      setAddPersonnelActive(false);
    } else {
      setOprativePersonnal(personnel);
      setOpenDeleteDialog(true);
    }
  };
  const handleConfirmClose = () => {
    setOpenDeleteDialog(false);
  };
  const handleStudyCheckbox = (e: any, _: number) => {
    let objArr: any = checkedCheckBoxval;
    if (e.target.checked) {
      objArr.push(e.target.value);
    } else {
      objArr = checkedCheckBoxval.filter((item: any) => item !== e.target.value);
    }
    setcheckedCheckBoxval(objArr);
  };
  const handleSaveStudyActivity = async () => {
    const tempListOfPersonnals = listOfPersonnals.map((personnal: any) => {
      if (oprativePersonnal.id === personnal.id) {
        return {
          ...personnal,
          site_per_activities: checkedCheckBoxval
            .map((item: any) => {
              return item;
            })
            .join(','),
          key: crypto.randomUUID()
        };
      } else {
        return personnal;
      }
    });
    setListOfPersonnals(tempListOfPersonnals);
    if (isSaveDisable) {
      setIsSaveDisable(false);
    }
    setOpenActivitiesDilog(false);
  };
  const handleSitePersonalChange = (e: any, id: string) => {
    setListOfPersonnals(
      listOfPersonnals.map((personnel: any) => {
        if (personnel.id === id) {
          return { ...personnel, site_per_training: e.target.value };
        } else {
          return personnel;
        }
      })
    );
    if (isSaveDisable) {
      setIsSaveDisable(false);
    }
  };
  const handleCloseStudyActivity = async () => {
    const tempListOfPersonnals = listOfPersonnals.map((personnal: any) => {
      if (oprativePersonnal.id === personnal.id) {
        return {
          ...personnal,
          key: crypto.randomUUID()
        };
      } else {
        return personnal;
      }
    });
    setListOfPersonnals(tempListOfPersonnals);
    setOpenActivitiesDilog(false);
  };
  const newGroup = groups.map((ele: any) => {
    if (ele.groupName === 'siteContactInformation_SitePersonal_second_group') {
      return {
        ...ele,
        fields: ele.fields.map((item: any) => {
          if (item.name === 'site_per_login') {
            return {
              ...item,
              disabled: false
            };
          } else {
            return item;
          }
        })
      };
    } else {
      return ele;
    }
  });

  const newStudyActEnableGroup = groups.map((ele: any) => {
    if (ele.groupName === 'siteContactInformation_SitePersonal_second_group') {
      return {
        ...ele,
        fields: ele.fields.map((item: any) => {
          if (item.name === 'site_per_login' || item.name === 'site_per_activities') {
            return {
              ...item,
              disabled: false
            };
          } else {
            return item;
          }
        })
      };
    } else {
      return ele;
    }
  });

  const studyActEnableGroup = groups.map((ele: any) => {
    if (ele.groupName === 'siteContactInformation_SitePersonal_second_group') {
      return {
        ...ele,
        fields: ele.fields.map((item: any) => {
          if (item.name === 'site_per_activities') {
            return {
              ...item,
              disabled: false
            };
          } else {
            return item;
          }
        })
      };
    } else {
      return ele;
    }
  });
  useEffect(() => {
    if ((createSitePersonalSuccess || updateSitePersonalSuccess) && !createSitePersonalIsError) {
      setIsSaveDisable(true);
      setAddPersonnelActive(false);
      dispatch(setMessage({ msgDetails: 'Data updated', severity: 'success' }));
    }
  }, [createSitePersonalSuccess, updateSitePersonalSuccess]);
  useEffect(() => {
    const addedFromReqId = `personnel${listOfPersonnals.length - 1}`;
    const curentDiv: any = document.getElementById(addedFromReqId);
    if (curentDiv) {
      curentDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  }, [listOfPersonnals?.length]);
  useEffect(() => {
    if (deleteSitePersonnelData && deleteSitePersonnelIsSuccess && !deleteSitePersonnelIsLoading) {
      dispatchApp(setMessage({ msgDetails: 'Deleted Successfully', severity: 'success' }));
      setListOfPersonnals(listOfPersonnals.filter((ele: any) => ele.id !== oprativePersonnal.id));
      setOpenDeleteDialog(false);
    }
    if (
      deleteSitePersonnelIsError &&
      !deleteSitePersonnelIsSuccess &&
      !deleteSitePersonnelIsLoading &&
      deleteSitePersonnelError
    ) {
      const errorData: any = deleteSitePersonnelError;
      dispatchApp(
        setMessage({
          msgDetails: `${errorData?.status} ${
            errorData?.data?.context?.message || errorData?.data?.detail || 'Error Data'
          }`,
          severity: 'error'
        })
      );
      setOpenDeleteDialog(false);
    }
  }, [
    deleteSitePersonnelIsError,
    deleteSitePersonnelIsSuccess,
    deleteSitePersonnelData,
    deleteSitePersonnelIsLoading,
    deleteSitePersonnelError
  ]);

  const hadleDeletePersonal = async () => {
    const reqObj = {
      deleted_by: user
    };
    await deleteSitePersonnel({
      data: reqObj,
      personnel_id: oprativePersonnal.id,
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite,
      appName: process.env.REACT_APP_NAME
    });
    setIsEnableAddPer(false);
    setConfirmExitValue(dispatch, false);
  };
  const navigateToForm1572 = () => {
    dispatch(setPath('SitePersonal'));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'studyLogs');
    setTabVal(currentTabinfo[0].index);
  };

  const [isexitopen, setIsexitopen] = useState(false);
  const [navigatecmp, setNavigatecmp] = useState('');

  const handleClose = () => {
    setIsexitopen(false);
  };

  const handleYes = () => {
    if (navigatecmp === 'DOA') {
      handleClickStudyLogs('DOA');
    } else if (navigatecmp === '1572') {
      navigateToForm1572();
    } else if (navigatecmp === 'Training Log') {
      handleClickStudyLogs('SIVTL');
    }

    setIsexitopen(false);
    dispatch(setIsbacktositepersonnel(true));
  };

  return (
    <Box>
      <AccordionDetails sx={{ pt: 2 }}>
        <Box className="site-personnel-block" style={{ maxHeight: '54vh', minHeight: '310', overflowY: 'auto' }}>
          {listOfPersonnals && listOfPersonnals?.length > 0
            ? listOfPersonnals.map((personnel: any) => {
                const formRef: any = createRef();
                formRefs.current.push({ formRef, id: personnel.id });
                return (
                  <Box
                    className={`card  ${
                      (isEmailErrorBlock && personnel.isNew) || duplicateIds.includes(personnel.id) ? 'errorCard' : ''
                    }`}
                    key={personnel.key}
                    id={personnel.id}
                  >
                    {!personnel.isNew ? (
                      <Checkbox
                        checked={selectedPersonnals.includes(personnel.id)}
                        className="card-select-check"
                        onChange={e => handleRequest(personnel.id, e)}
                        disabled={!(checkPermission('request_site_access') || checkPermission('delete_sitepersonnel'))}
                      />
                    ) : null}
                    <FormLayoutBuilder
                      initialValues={personnel}
                      rules={rules}
                      ref={formRef}
                      groups={
                        personnel.isNew
                          ? personnel?.site_per_role && personnel?.site_per_role != 'Sponsor Read Only'
                            ? newStudyActEnableGroup
                            : newGroup
                          : personnel?.site_per_role && personnel?.site_per_role != 'Sponsor Read Only'
                          ? studyActEnableGroup
                          : groups
                      }
                      columnSpacing={2}
                      onFocus={(cmp: any) => onClick(cmp, personnel)}
                      dateFormat={userPreferedDateFormat}
                      onChange={(key: any, value: any) =>
                        handlechangeFunction(key, value, personnel.id, personnel?.isNew)
                      }
                    />
                    <Grid container spacing={2}>
                      <Grid item md={6} className="radio-section">
                        <Grid container>
                          <Grid item md={7}>
                            <FormLabel component="legend">
                              {' '}
                              FICS Training Required? <span style={{ color: 'red' }}>*</span>
                            </FormLabel>
                          </Grid>
                          <Grid item md={5}>
                            <FormControl component="fieldset" className="pi-radio-action">
                              <RadioGroup
                                value={personnel.site_per_training}
                                onChange={(e: any) => handleSitePersonalChange(e, personnel.id)}
                                name="site_per_training"
                              >
                                <FormControlLabel
                                  disabled={!checkPermission('fics_tranning_required')}
                                  value={'Y'}
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  disabled={!checkPermission('fics_tranning_required')}
                                  value={'N'}
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item md={5}>
                        <Button
                          variant="text"
                          disabled={
                            !(checkPermission('view_site_doa') && checkPermission('view_study_logs')) || personnel.isNew
                          }
                          onClick={() => {
                            setNavigatecmp('DOA');
                            setIsexitopen(true);
                          }}
                          sx={{ fontSize: '15px !important' }}
                        >
                          DOA
                        </Button>
                        <Button
                          variant="text"
                          disabled={
                            !(
                              checkPermission('view_study_logs') &&
                              checkPermission('view_1572_form') &&
                              (personnel.site_per_role === 'Principal investigator' ||
                                personnel.site_per_role === 'Sub-Investigator')
                            ) || personnel.isNew
                          }
                          onClick={() => {
                            setNavigatecmp('1572');
                            setIsexitopen(true);
                          }}
                          sx={{ fontSize: '15px !important' }}
                        >
                          1572
                        </Button>
                        <Button
                          variant="text"
                          className="capitalize"
                          disabled={
                            !(checkPermission('view_site_siv_training') && checkPermission('view_study_logs')) ||
                            personnel.isNew
                          }
                          onClick={() => {
                            setNavigatecmp('Training Log');
                            setIsexitopen(true);
                          }}
                          sx={{ fontSize: '15px !important' }}
                        >
                          SIV Training Log
                        </Button>
                      </Grid>
                      {selectedPersonnals.includes(personnel.id) || personnel.isNew ? (
                        <Grid item md={1} justifyContent="end">
                          <IconButton className="delete-card-icon" onClick={() => handleRemovePersonnal(personnel)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      ) : null}
                    </Grid>
                  </Box>
                );
              })
            : null}
        </Box>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item md={6}>
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                onClick={handleAddPersonnel}
                id="btnAdd"
                disabled={addPersonnelActive || !checkPermission('create_site_personnel')}
              >
                + ADD PERSONNEL
              </Button>
              <Button
                variant="contained"
                disabled={!checkPermission('request_site_access') || !selectedPersonnals.length}
                onClick={handleClickOpen}
              >
                {reqBtnText}
              </Button>
              <UserAccessRequestModal
                setReqBtnText={setReqBtnText}
                studyId={studyId}
                open={openUserAccess}
                setOpen={setOpenUserAccess}
                selectedPersonnals={selectedPersonnals}
                setSelectedPersonnals={setSelectedPersonnals}
              />
            </Stack>
          </Grid>
          {checkPermission('fics_tranning_required') || checkPermission('create_site_personnel') ? (
            <Grid item md={6} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                <Button variant="text" onClick={handleSave} disabled={isSaveDisable}>
                  SAVE
                </Button>
              </Stack>
            </Grid>
          ) : null}
        </Grid>
      </AccordionDetails>
      <Drawer anchor={'bottom'} open={openDrawer} PaperProps={{ style: { height: '50vh' } }}>
        <Box sx={{ position: 'relative' }} role="presentation">
          <IconButton
            aria-label="close"
            onClick={() => setOpenDrawer(false)}
            sx={{
              position: 'sticky',
              left: '100%',
              top: 8,
              color: theme => theme.palette.grey[500]
            }}
          >
            <CloseIcon style={{ cursor: 'pointer' }} />
          </IconButton>
          <Box className="studyActivityWrapper">
            {studyActivitiesData.map((ele: any, index: number) => {
              return (
                <Typography variant="subtitle1" key={`studyActivitiesData${index}`}>
                  <strong>{`${ele.id}`}</strong>. {`${ele.ele}`}
                </Typography>
              );
            })}
          </Box>
        </Box>
      </Drawer>
      <PopupComponent
        open={openActivitiesDilog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Study Activity</DialogTitle>
        <DialogContent className="study-activity-modal">
          <DialogContentText id="alert-dialog-description">Assign Activity(ies) to Personnel:</DialogContentText>
          {studyActivitiesData.map((ele: any) => {
            const found = checkedCheckBoxval.find((item: any) => item == ele.id);
            return (
              <FormControlLabel
                key={ele.id}
                checked={found}
                control={<Checkbox value={ele.id} onChange={(e: any) => handleStudyCheckbox(e, ele.id)} />}
                label={
                  <Typography variant="subtitle2" gutterBottom>
                    {`${ele.id}.${ele.ele}`}
                  </Typography>
                }
              />
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseStudyActivity} className="grey-btn-link">
            Cancel
          </Button>
          <Button autoFocus onClick={handleSaveStudyActivity}>
            Save
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={openDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{'Remove Personnel'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want remove ${oprativePersonnal.site_per_first_name} ${oprativePersonnal.site_per_last_name} from the Site Personnel?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose} className="grey-btn-link">
            CANCEL
          </Button>
          <Button onClick={hadleDeletePersonal} autoFocus>
            REMOVE
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={isexitopen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Redirecting'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You will be redirected to {navigatecmp} page in study logs, are you sure you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            Close
          </Button>
          <Button onClick={handleYes} autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </PopupComponent>
    </Box>
  );
};

export default SitePersonal;
